export default "__VITE_ASSET__De1cN3CD__"